(() => {
  const globalKey = 'FogattiBuyingGuide';
  if (window[globalKey]) return;

  const closeAll = (exception) => {
    document.querySelectorAll('[data-fg-buying-guide][open]').forEach((details) => {
      if (details !== exception) details.open = false;
    });
  };

  document.addEventListener('click', (event) => {
    const current = event.target.closest('[data-fg-buying-guide]');
    if (!current) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openGuide = document.querySelector('[data-fg-buying-guide][open]');
    if (!openGuide) return;
    openGuide.open = false;
    openGuide.querySelector('summary')?.focus();
  });

  document.addEventListener('toggle', (event) => {
    const guide = event.target.closest?.('[data-fg-buying-guide]');
    if (guide?.open) closeAll(guide);
  }, true);

  window[globalKey] = { closeAll };
})();
